$(document).ready(function() {
    localStorageProcessing = true;
    localStorage.setItem("localStorageWork", true);
    let form = $('product-form form');
    var formData = form.serializeArray();
    formData = formData.filter(item => (item.name.includes('properties') || item.name.includes('prop') || item.name.includes('frame-selector')))
    formData = formData.filter(item => !form_filters.some(filter => item.name.includes(filter)))

    let handle_at_end_items = ['bp-illustration-value', 'bp-language-selector'];

    // function storeFormData() {
    //     formData.forEach(item => {
    //         localStorage.setItem(item.name, item.value);
    //     });
    // }

    function cleanUrl() {
        var url = new URL(window.location.href);
        url.searchParams.delete('values');
        window.history.replaceState({}, document.title, url.toString());
    }

    function AttachStorageListeners() {
        formData.forEach(item => {
            $(`[name="${item.name}"]`).on('change input', function(){
                localStorage.setItem($(this).attr('name'), $(this).val());
            });
        });
    }

    function fillFormFromLocalStorage() {
        // i need to handle illustration change at end as it changes the length if done before
        let handle_at_end = [];
        formData.forEach(item => {
            const storedValue = localStorage.getItem(item.name);
            const element = $(`[name="${item.name}"]`)
            if (handle_at_end_items.some((item) => element.hasClass(item))) {
                handle_at_end.push(item);
            }
            else {
                if(storedValue !== null && element) {
                    if(element.is(':radio')) {
                        element.filter(`[value="${storedValue}"]`).click();
                        if (element.hasClass('bp-background-radio')){
                            let left_scroll = ($(`.bp-swatch-container:has(.bp-background-radio:checked)`).position().left + $(`.bp-bg-block:has(.bp-background-radio:checked)`).scrollLeft() - $(`.bp-bg-block:has(.bp-background-radio:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-background-radio:checked)`).width()))
                            $(`.bp-bg-block:has(.bp-background-radio:checked)`).animate({
                                scrollLeft: left_scroll
                            }, {
                                duration: 200,  // Animation duration in milliseconds
                                easing: 'linear' // Linear easing for smooth, constant speed
                            });
                        }
                        else if (element.hasClass('bp-illustration-radio')){
                            let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width()))
                            $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).animate({
                                scrollLeft: left_scroll
                            }, {
                                duration: 200,  // Animation duration in milliseconds
                                easing: 'linear' // Linear easing for smooth, constant speed
                            });
                        }
                    }
                    else {
                        element.val(storedValue)
                        element.change();
                    }
                }
            }
        });
        handle_at_end.forEach( item => {
            const storedValue = localStorage.getItem(item.name);
            const element = $(`[name="${item.name}"]`)
            if(storedValue !== null && element) {
                if(element.is(':radio')) {
                    element.filter(`[value="${storedValue}"]`).click();
                }
                else {
                    element.val(storedValue)
                    element.change();
                }
            }
        })
    }

    function fillFormFromURLParams(values = '') {
        let encoded_values = '';
        if(values) {
            encoded_values = values;
        }
        else {
            const params = new URLSearchParams(window.location.search);
            encoded_values = params.get('values')
        }
        let handle_at_end = [];
        if(encoded_values){
            let sp_encoded_string = decodeURIComponent(encoded_values);
            let jsonString = window.mySpecialDecoding(sp_encoded_string)
            const obj = JSON.parse(jsonString);
            formData.forEach(item => {
                let found_obj = obj.filter((itm) => itm.name == item.name)
                var storedValue = '';
                if(found_obj.length) {
                    storedValue = found_obj[0].value;
                    localStorage.setItem(item.name, storedValue);
                }
                else {
                    localStorage.removeItem(item.name);
                    return;
                }
                const element = $(`[name="${item.name}"]`);
                if (handle_at_end_items.some((item) => element.hasClass(item))) {
                    handle_at_end.push(item);
                }
                else {
                    if(storedValue !== null && element) {
                        if(element.is(':radio')) {
                            element.filter(`[value="${storedValue}"]`).click();
                            if (element.hasClass('bp-background-radio')){
                                let left_scroll = ($(`.bp-swatch-container:has(.bp-background-radio:checked)`).position().left + $(`.bp-bg-block:has(.bp-background-radio:checked)`).scrollLeft() - $(`.bp-bg-block:has(.bp-background-radio:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-background-radio:checked)`).width()))
                                $(`.bp-bg-block:has(.bp-background-radio:checked)`).animate({
                                    scrollLeft: left_scroll
                                }, {
                                    duration: 200,  // Animation duration in milliseconds
                                    easing: 'linear' // Linear easing for smooth, constant speed
                                });
                            }
                            else if (element.hasClass('bp-illustration-radio')){
                                let left_scroll = ($(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).position().left + $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).scrollLeft() - $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width() + (2 * $(`.bp-swatch-container:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).width()))
                                $(`.bp-illustration-block:has(.bp-illustration-radio[data-index="${element[0].dataset.index}"]:checked)`).animate({
                                    scrollLeft: left_scroll
                                }, {
                                    duration: 200,  // Animation duration in milliseconds
                                    easing: 'linear' // Linear easing for smooth, constant speed
                                });
                            }
                        }
                        else {
                            element.val(storedValue)
                            element.change();
                        }
                    }
                }
            });
            handle_at_end.forEach( item => {
                let found_obj = obj.filter((itm) => itm.name == item.name)
                var storedValue = '';
                if(found_obj.length) {
                    storedValue = found_obj[0].value;
                }
                else {
                    localStorage.removeItem(item.name);
                    return;
                }
                const element = $(`[name="${item.name}"]`)
                if(storedValue !== null && element) {
                    if(element.is(':radio')) {
                        element.filter(`[value="${storedValue}"]`).click();
                    }
                    else {
                        element.val(storedValue)
                        element.change();
                    }
                }
            })
            if(typeof preview_template === 'undefined' || preview_template == false)
            cleanUrl();
        }
    }

    function makeURL() {
        formData = form.serializeArray();
        formData = formData.filter(item => (item.value != '' || by_default_valued_properties.some(prop => item.name.includes(prop))));
        formData = formData.filter(item => (item.name.includes('properties') || item.name.includes('prop') || item.name.includes('frame-selector')))
        formData = formData.filter(item => !form_filters.some(filter => item.name.includes(filter)))

        const jsonString = JSON.stringify(formData);
        let sp_encoded_string = window.myVerifiedEncoding(jsonString);
        const encoded_string = encodeURIComponent(sp_encoded_string);

        var url_visit = new URL(window.location.href);
        url_visit.searchParams.delete("item_key");
        url_visit.searchParams.append("values", encoded_string)
        return url_visit.href
    }

    function makePreviewURL() {
        var url_visit = new URL(makeURL());
        url_visit.searchParams.append("view", 'petposter_preview')
        return url_visit.href
    }

    AttachStorageListeners();

    function finishFormInit() {
        // Restore custom text mode if it was active when saved
        let flag = $(`#bp-custom-text-flag-1`);
        let textarea = $(`#bp-custom-text-1`);
        if(flag.length && flag.val() === 'true' && textarea.length && textarea.val().trim() !== '') {
            $(`.bp-custom-text-toggle[data-index="1"]`).click();
            textarea.val(textarea.val());
            textarea.trigger('input');
        }
        localStorageProcessing = false;
        localStorage.removeItem("localStorageWork");
        console.log(makeURL());
    }

    // If we arrived via a "Save design for later" short link (?d=<token>),
    // fetch the full state from the server before restoring the form. The
    // token survives email click-tracking; the legacy `?values=<blob>` param
    // was getting truncated by Klaviyo's redirect for long URLs.
    (function init() {
        var params = new URLSearchParams(window.location.search);
        var token = (params.get('d') || '').replace(/[^a-z0-9]/gi, '');
        if (!token) {
            fillFormFromURLParams();
            fillFormFromLocalStorage();
            finishFormInit();
            return;
        }
        var apiBase = (typeof AI_API_URL !== 'undefined' ? AI_API_URL : 'https://petposter.vercel.app');
        fetch(apiBase + '/api/save-design?token=' + encodeURIComponent(token))
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(data) {
                if (data && data.values) {
                    fillFormFromURLParams(data.values);
                } else {
                    fillFormFromURLParams();
                }
                // The AI portrait URL lives in a hidden input that's bound to
                // the form via a `form=` attribute rather than being a DOM
                // descendant. jQuery's form.serializeArray() skips those, so
                // the URL is stored separately on the payload — apply it here.
                if (data && data.ai_portrait) {
                    $('.bp-ai-portrait-url').val(data.ai_portrait).trigger('change');
                }
                // Strip ?d= so a refresh doesn't re-fetch
                var u = new URL(window.location.href);
                u.searchParams.delete('d');
                window.history.replaceState({}, document.title, u.toString());
                fillFormFromLocalStorage();
                finishFormInit();
                // Notify other handlers (ai-portrait) that the hidden fields
                // are now populated so they can re-render the poster preview.
                $(document).trigger('pp:design-restored');
            })
            .catch(function() {
                fillFormFromURLParams();
                fillFormFromLocalStorage();
                finishFormInit();
            });
    })();

    // Save Design for Later — custom email modal + Klaviyo tracking
    $('button.bp-save-for-later-btn').click(function(){
        // Get pet name and preview image
        var petName = '';
        try { petName = $('.bp-pet-name').first().text().trim() || ''; } catch(e) {}
        var previewImg = '';
        try {
            // Prefer AI portrait URL (already on Vercel Blob), then illustration img
            var aiPortrait = $('.bp-ai-portrait-url').val();
            previewImg = aiPortrait || $('.bp-illustration-img').first().attr('src') || '';
        } catch(e) {}

        // Build the local fallback URL (still useful if the save fails)
        var localDesignUrl = makeURL();

        // Serialize the form state into the compact `values` blob so we can
        // persist it server-side and email a short `?d=<token>` link that
        // survives Klaviyo's click-tracking truncation.
        var valuesParam = '';
        try {
            var u = new URL(localDesignUrl);
            valuesParam = u.searchParams.get('values') || '';
        } catch(e) {}

        var baseUrl = window.location.origin + window.location.pathname;

        if (!valuesParam) {
            // Nothing to persist — just show the modal with the local URL.
            window.ppShowSaveModal(localDesignUrl, petName, previewImg);
            return;
        }

        var apiBase2 = (typeof AI_API_URL !== 'undefined' ? AI_API_URL : 'https://petposter.vercel.app');
        fetch(apiBase2 + '/api/save-design', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                values: valuesParam,
                ai_portrait: $('.bp-ai-portrait-url').val() || '',
                pet_name: petName,
                product_url: window.location.href,
                tool: document.querySelector('.photoposter-section') ? 'Photo Poster' : 'Pet Poster'
            })
        })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
            var shortUrl = (data && data.token)
                ? baseUrl + '?d=' + encodeURIComponent(data.token)
                : localDesignUrl;
            window.ppShowSaveModal(shortUrl, petName, previewImg);
        })
        .catch(function() {
            // Network/server issue — fall back to the long URL so the user
            // still gets something functional in their inbox.
            window.ppShowSaveModal(localDesignUrl, petName, previewImg);
        });
    });
});
